import React from "react";
import {
  IconGavel,
  IconPhone,
  IconMail,
  IconUserShield,
  IconWorldWww,
  IconBuilding,
  IconShieldLock,
  IconLicense,
} from "@tabler/icons-react";
import { navigate } from "vike/client/router";
import { companyContact } from "#root/database/companyContact";
import { SpotlightActionData } from "@mantine/spotlight";

const c = companyContact[0];

function safe(value?: string): string {
  return value?.trim() || "Not provided";
}

async function onSubmit(route: string) {
  const navigationPromise = navigate(route);
  await navigationPromise;
}

export const legalNotice: SpotlightActionData[] = [
  {
    id: "legal-identity",
    label: "Legal Identity",
    description: `${safe(c.name)} — ${safe(c.description)}`,
    onClick: () => onSubmit("/legal-notice#identity"),
    leftSection: <IconBuilding size={24} stroke={1.5} aria-label="Legal identity" />,
  },
  {
    id: "legal-address",
    label: "Legal Address",
    description: `${safe(c.postalAddress?.streetAddress)}, ${safe(c.postalAddress?.addressLocality)} ${safe(c.postalAddress?.postalCode)}, ${safe(c.postalAddress?.addressCountry)}`,
    onClick: () => onSubmit("/legal-notice#address"),
    leftSection: <IconBuilding size={24} stroke={1.5} aria-label="Legal address" />,
  },
  {
    id: "legal-phone",
    label: "Phone (Legal)",
    description: `Call: ${safe(c.phone)}`,
    onClick: () => window.open(`tel:${c.phone}`, "_blank", "noreferrer,noopener"),
    rightSection: <IconPhone size={24} stroke={1.5} aria-label="Phone contact" />,
  },
  {
    id: "legal-email",
    label: "Email (Legal)",
    description: `Email: ${safe(c.email)}`,
    onClick: () => window.open(`mailto:${c.email}`, "_blank", "noreferrer,noopener"),
    rightSection: <IconMail size={24} stroke={1.5} aria-label="Email contact" />,
  },
  {
    id: "legal-website",
    label: "Website",
    description: `URL: ${safe(c.url)}`,
    onClick: () => window.open(c.url || "#", "_blank", "noreferrer,noopener"),
    rightSection: <IconWorldWww size={24} stroke={1.5} aria-label="Official website" />,
  },
  {
    id: "legal-hosting",
    label: "Hosting Provider",
    description: `${c.legal?.services?.map((s) => s.provider).join(", ") || "Not provided"}`,
    onClick: () => onSubmit("/legal-notice#hosting"),
    leftSection: <IconWorldWww size={24} stroke={1.5} aria-label="Hosting" />,
  },
  {
    id: "legal-ip",
    label: "Intellectual Property",
    description: safe(c.legal?.rightsAndMention?.trademark),
    onClick: () => onSubmit("/legal-notice#intellectual-property"),
    leftSection: <IconLicense size={24} stroke={1.5} aria-label="IP" />,
  },
  {
    id: "legal-liability",
    label: "Liability",
    description:
      "a11yStart shall not be held liable for any damages or interruptions resulting from the use of this website or its services. Use of the site implies full responsibility by the user.",
    onClick: () => onSubmit("/legal-notice#liability"),
    leftSection: <IconUserShield size={24} stroke={1.5} aria-label="Liability" />,
  },
  {
    id: "legal-cnil",
    label: "Data Protection & CNIL",
    description: `Personal data is processed under legitimate interest and stored securely within the EU. ${safe(c.legal?.dataProtection?.cnilDeclaration)}`,
    onClick: () => window.open("https://www.cnil.fr/en/home", "_blank", "noreferrer,noopener"),
    rightSection: <IconShieldLock size={24} stroke={1.5} aria-label="CNIL" />,
  },
  {
    id: "legal-update",
    label: "Policy Updates",
    description: "This legal notice may be updated without prior notice. Users are advised to consult it regularly.",
    onClick: () => onSubmit("/legal-notice#update"),
    rightSection: <IconGavel size={24} stroke={1.5} aria-label="Update" />,
  },
];
